import { Pipe, PipeTransform } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { getTextIdByApplicationLanguageType } from '@fi-shared/fi-content-language-shared/get-tex-id-by-application-language-type';

@Pipe({
    name: 'fiLanguageName',
    standalone: false,
})
export class LanguageNamePipe implements PipeTransform {
    constructor(private appTextService: AppTextService) {}

    transform(value: any, args?: any): any {
        return this.appTextService.get(getTextIdByApplicationLanguageType(value));
    }
}
